import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { WorkflowRunPage } from '@/features/workflows/workflow-run-page';

type RunTab = 'summary' | 'events';
const isRunTab = (value: unknown): value is RunTab => value === 'summary' || value === 'events';

export const Route = createFileRoute('/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId')({
  validateSearch: (search: Record<string, unknown>): { tab: RunTab } => ({
    tab: isRunTab(search['tab']) ? search['tab'] : 'summary',
  }),
  component: WorkflowRunRoute,
});

function WorkflowRunRoute() {
  const { tenant, projectId, workflowId, runId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();

  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="workflows"
      crumbs={[
        { label: t('nav.items.workflows') },
        { label: workflowId, mono: true },
        { label: runId, mono: true },
      ]}
    >
      <WorkflowRunPage
        tenantId={tenant}
        projectId={projectId}
        workflowId={workflowId}
        runId={runId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
